window.sporttapeGetCompareAtIncCents = function (variant) {
  const compareAt = variant?.compare_at_price;
  const price = variant?.price;

  if (!compareAt || compareAt <= 0 || !price) {
    return null;
  }

  if (compareAt > price) {
    return compareAt;
  }

  if (compareAt < price) {
    const scaledCompareAt = Math.round(compareAt * 1.2);
    if (scaledCompareAt > price) {
      return scaledCompareAt;
    }
  }

  return null;
};

window.sporttapeIsVariantOnSale = function (variant) {
  return window.sporttapeGetCompareAtIncCents(variant) !== null;
};

window.sporttapeShouldShowExVat = function () {
  return document.documentElement.getAttribute('data-vat-mode') === 'ex';
};

window.sporttapeExVatCents = function (incCents) {
  const n = parseInt(incCents, 10);
  if (!n || isNaN(n)) {
    return 0;
  }

  return Math.round(n / 1.2);
};

window.sporttapeParsePackSizeOption = function (option) {
  if (!option) {
    return null;
  }

  const trimmed = String(option).trim();

  if (/^single(\s+(roll|bottle|pack))?$/i.test(trimmed)) {
    return 1;
  }

  let match = trimmed.match(/^(\d+)\s*rolls?$/i);
  if (match) {
    return parseInt(match[1], 10);
  }

  match = trimmed.match(/^(\d+)\s*pack$/i);
  if (match) {
    return parseInt(match[1], 10);
  }

  match = trimmed.match(/^(box|pack)\s+of\s+(\d+)$/i);
  if (match) {
    return parseInt(match[2], 10);
  }

  match = trimmed.match(/^roll\s+of\s+(\d+)$/i);
  if (match) {
    return parseInt(match[1], 10);
  }

  return null;
};

window.sporttapeGetVariantPackSize = function (variant) {
  if (!variant) {
    return 0;
  }

  let packSize = 0;
  [variant.option1, variant.option2, variant.option3].forEach(function (option) {
    const parsed = window.sporttapeParsePackSizeOption(option);
    if (parsed !== null) {
      packSize = parsed;
    }
  });

  if (packSize > 0) {
    return packSize;
  }

  const title = variant.title || '';
  if (/single/i.test(title)) {
    return 1;
  }

  if (/rolls|pack|box/i.test(title)) {
    const match = title.match(/(\d+)/);
    if (match) {
      return parseInt(match[1], 10);
    }
  }

  const productJsonElement = document.querySelector('[data-product-json]');
  if (productJsonElement) {
    try {
      const productData = JSON.parse(productJsonElement.textContent);
      const defaultPackSize = parseInt(productData.sporttape_default_pack_size, 10);
      if (!isNaN(defaultPackSize) && defaultPackSize > 0) {
        return defaultPackSize;
      }
    } catch (error) {
      // ignore malformed product JSON
    }
  }

  return 0;
};

window.sporttapeGetPerUnitIncCents = function (variant) {
  const packSize = window.sporttapeGetVariantPackSize(variant);
  if (!variant?.price || packSize <= 0) {
    return null;
  }

  return Math.round(variant.price / packSize);
};

window.sporttapeGetPerUnitDisplayCents = function (variant, showExVat) {
  const packSize = window.sporttapeGetVariantPackSize(variant);
  if (!variant?.price || packSize <= 0) {
    return null;
  }

  if (showExVat && packSize === 1) {
    return window.sporttapeGetSaleDisplayCents(variant, true);
  }

  const perUnitInc = Math.round(variant.price / packSize);
  return showExVat ? window.sporttapeExVatCents(perUnitInc) : perUnitInc;
};

window.sporttapeGetSaleDisplayCents = function (variant, showExVat) {
  if (!variant?.price) {
    return 0;
  }

  return showExVat ? window.sporttapeExVatCents(variant.price) : variant.price;
};

window.sporttapeGetCompareAtDisplayCents = function (variant, showExVat) {
  const compareInc = window.sporttapeGetCompareAtIncCents(variant);
  if (!compareInc) {
    return null;
  }

  return showExVat ? window.sporttapeExVatCents(compareInc) : compareInc;
};

window.sporttapeGetSavingsPercent = function (variant, showExVat) {
  const compareDisplay = window.sporttapeGetCompareAtDisplayCents(variant, showExVat);
  const saleDisplay = window.sporttapeGetSaleDisplayCents(variant, showExVat);

  if (!compareDisplay || compareDisplay <= saleDisplay) {
    return 0;
  }

  return Math.round(((compareDisplay - saleDisplay) / compareDisplay) * 100);
};

window.sporttapeGetSavingsAmountCents = function (variant, showExVat) {
  const compareDisplay = window.sporttapeGetCompareAtDisplayCents(variant, showExVat);
  const saleDisplay = window.sporttapeGetSaleDisplayCents(variant, showExVat);

  if (!compareDisplay || compareDisplay <= saleDisplay) {
    return 0;
  }

  return compareDisplay - saleDisplay;
};

window.sporttapeFormatMoney = function (cents, format) {
  if (typeof formatMoney === 'function') {
    return formatMoney(cents, format);
  }

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const settings = window.themeVariables && window.themeVariables.settings;
  const formatString = format || (settings && settings.moneyFormat) || '{{amount}}';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) {
    return formatWithDelimiters(cents, 2);
  }

  let value = '';
  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
